// extracted by mini-css-extract-plugin
module.exports = {"pagination":"blogPagination_pagination__aqGCK","dot":"blogPagination_dot__TeDFn","current":"blogPagination_current__2xKCc"};